@if (visible) {
  <aside class="version-update-banner">
    <span>A new version is available.</span>
    <button class="button refresh-button" (click)="reload()">REFRESH</button>
    <button class="close">
      <span (click)="dismiss()">&#x00D7;</span>
    </button>
  </aside>
}
